// Based on https://github.com/Stychen/React-Newline-to-Break

import React from "react";

const newline = "\n";

const nl2br = text => {
  if (typeof text === "number") {
    return text;
  }

  if (typeof text !== "string") {
    return "";
  }

  const lines = text.split(newline);

  return lines.map((line, i) => (
    <span key={i}>
      {line}
      <br />
    </span>
  ));
};

export default nl2br;
